var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"app-radio"},[_c('input',_vm._b({attrs:{"data-value":_vm.dataValue,"name":_vm.name,"type":"radio"},domProps:{"checked":_vm.value == _vm.dataValue},on:{"change":_vm.update}},'input',_vm.$attrs,false)),_vm._v(" "),_c('span'),_vm._v(" "),(_vm.label)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.label)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }